import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      loginPageImage: (state) => state._core.application.loginPageImage
    })
  }
};
